import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getCommunicationsPreferences: configurationServices.getMerchantCommunicationsPreferences,
    editCommunicationsPreferences: configurationServices.editMerchantCommunicationsPreferences,
  },
  [configurationTypes.returnsPortal]: {
    getCommunicationsPreferences: configurationServices.getPortalCommunicationsPreferences,
    editCommunicationsPreferences: configurationServices.editPortalCommunicationsPreferences,
  },
}
